










































import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import Util from '@/lib/util'
import AbpBase from "@/lib/abpbase";
import Approval from "@/store/entities/approval";
@Component
export default class EditApproval extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  approval: Approval = new Approval();
  disableTime: Array<any> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 18, 19, 20, 21, 22, 23];
  users: Array<any> = [];
  offices: Array<any> = [];
  save() {
      (this.$refs.approvalForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if(this.approval.startTime >= this.approval.endTime){
          this.$Message.error(this.L("ErrorTimeMessage"));
          return;
        }
        await this.$store.dispatch({
          type: "approval/updateAppointment",
          data: this.approval,
        });
        (this.$refs.approvalForm as any).resetFields();
        this.$emit("edit-success");
        this.$emit("input", false);
      }
    });
  }

  cancel() {
      (this.$refs.approvalForm as any).resetFields();
      this.$emit("input", false);
  }

  visibleChange(value) {
    if (!value) {
      this.$emit("input", false);
    }else{
        this.approval= Util.extend(true,{},this.$store.state.approval.editApproval);
    }
  }

   async getOffices(){
    this.offices = await this.$store.dispatch({
      type: "office/getOffices"
    })
  }

  async getDefaultUsers(){
    this.users = await this.$store.dispatch({
      type: "user/getDefaultUsers"
    })
  }

  async created(){
    this.getDefaultUsers();
    this.getOffices();
  }
  approvalRule = {
    topic: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
    content: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
  };
}
